import { addToChainBefore } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    DispatchUpdateLoadParameter,
} from "@insite/client-framework/Store/Pages/OrderApprovalList/Handlers/UpdateSearchFields";
import clearDirtyFilters from "@store/Store/Pages/OrderApprovalList/Handlers/ClearDirtyFilters";

addToChainBefore(chain, DispatchUpdateLoadParameter, props => {
    if (props.parameter.type) {
        props.dispatch(clearDirtyFilters());
    }
});
